import { addActionInQueue, getActionsQueue, ISSUE_ACTION, removeActionFromQueue } from "util/ActionsQueueManager";
import {
    FETCH_ERROR,
    FETCH_SUCCESS,
    SIGNOUT_USER_SUCCESS,
    ERROR_OTHERS,

    FETCH_UNIT_ISSUES_START,
    ISSUES_DATA,

    ADD_COMMON_TASK_ISSUE_START,
    ADD_COMMON_TASK_ISSUE_SUCCESS,
    CURRENT_ACTIONS_QUEUE_DATA



} from "../../constants/ActionsTypes";
import axios from 'util/Api';
import { saveQueue } from "./ActionsQueue";
import { getUnitIssues, saveUnitIssues } from "util/LocalDataManager";

export const fetchIssues = (unitId) => {
    return (dispatch) => {
        dispatch({ type: FETCH_UNIT_ISSUES_START });
        axios.get('/issues', {
            params: {
                unitId: unitId
            },
            timeout: 5000,
        })
            .then(({ data }) => {
                if (data.result) {
                    dispatch({ type: FETCH_SUCCESS });
                    saveUnitIssues(unitId, data.result.issues); // Save issues to local storage
                    dispatch({ type: ISSUES_DATA, payload: data.result.issues });
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (!error.response) {
                    // Request timed out
                    console.log("payload: data.error", error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                    const localIssues = getUnitIssues(unitId); // Fallback to local data
                    if (localIssues.length > 0) {
                        dispatch({ type: ISSUES_DATA, payload: localIssues });
                        dispatch({ type: FETCH_SUCCESS });
                    }
                } else if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({ type: SIGNOUT_USER_SUCCESS });
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};

export const addcommontaskIssue = (issues, paramTime) => {
    // Time param is given when we save actions from queue
    return async (dispatch) => {
        const params = {
            ...issues
        };
        const time = paramTime || new Date()
        
        if (!paramTime) {
            await dispatch(saveQueue());
            if (getActionsQueue().length > 0) {
                // There is still a network error
                const nbActions = addActionInQueue(ISSUE_ACTION, params, time);
                dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                return;
            }
        }


        dispatch({ type: ADD_COMMON_TASK_ISSUE_START });
        return axios.post('/addcommontaskIssue', params, {
            timeout: 5000,
        })
            .then(({ data }) => {
                if (data.result) {
                    if (paramTime) {
                        const nbActions = removeActionFromQueue(ISSUE_ACTION, time);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                    }
                    dispatch({ type: ADD_COMMON_TASK_ISSUE_SUCCESS});
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (!error.response) {
                    // Request timed out
                    console.log("payload: data.error", error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                    dispatch({ type: ADD_COMMON_TASK_ISSUE_SUCCESS });
                    if (!paramTime) {
                        const nbActions = addActionInQueue(ISSUE_ACTION, params, time);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                    } else {
                        throw new Error("Network Error");
                    }
                } else if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({type: SIGNOUT_USER_SUCCESS});
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};


